export default {
    NoSelected: -1,
    ZeroPercent: 0,
    FivePercent: 5,
    EightPercent: 8,
    TenPercent: 10,
};